import * as Slot from '@/ui/primitives/slot'
import type { TextRef } from '@/ui/primitives/types'
import { cn } from '@/ui/utils'
import { forwardRef } from 'react'
import { Text as RNText } from 'react-native'
import { headerStyles } from './header.styles'
import type { HeaderProps } from './header.types'

const VARIANT_TO_ARIA_LEVEL = {
	h1: '1',
	h2: '2',
	h3: '3',
	h4: '4',
	h5: '5',
}

const Header = forwardRef<TextRef, HeaderProps>(
	({ className, asChild = false, variant = 'h1', ...props }, ref) => {
		const Component = asChild ? Slot.Text : RNText

		return (
			<Component
				role="heading"
				aria-level={VARIANT_TO_ARIA_LEVEL[variant]}
				className={cn(headerStyles({ variant }), className)}
				ref={ref}
				{...props}
			/>
		)
	}
)

Header.displayName = 'Header'

export { Header }
